
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#346662"}},[_c('path',{attrs:{"d":"M11.542 8.564v2.427a.545.545 0 01-.018.134.525.525 0 01-.513.418H.985a.523.523 0 01-.52-.463c-.007-.03-.007-.058-.007-.093V8.561a.522.522 0 01.894-.366.517.517 0 01.153.366v1.943h8.993V8.561a.522.522 0 011.044.003z"}}),_c('path',{attrs:{"d":"M9.029 5.925L6.446 8.438c-.003.007-.01.01-.014.014a.615.615 0 01-.34.167c-.01 0-.02.003-.031.003-.021.004-.042.004-.063.004l-.06-.004c-.01 0-.02-.003-.031-.003a.604.604 0 01-.34-.167l-.014-.014L2.97 5.925a.588.588 0 010-.846.63.63 0 01.869 0L5.392 6.59V1.056c0-.328.277-.597.613-.597.168 0 .322.068.434.174.112.109.18.256.18.423V6.59L8.17 5.08a.63.63 0 01.87 0 .599.599 0 01-.011.845z"}})])])
          )
        }
      }
    